import React from 'react';
import H from '../elements/H';
import Paragraph from '../elements/Paragraph';

interface LabelledCountProps {
  count: number;
  label: string;
}
const LabelledCount: React.FunctionComponent<
  LabelledCountProps & React.HTMLAttributes<HTMLElement>
> = ({ count, label, ...rest }) => {
  return (
    <div className="labelled-count" {...rest}>
      <H styling="h3" tag="div" data>
        {count}
      </H>
      <Paragraph small data>
        {label}
      </Paragraph>
    </div>
  );
};

export default LabelledCount;
